import * as React from 'react';

import setHocDisplayName from '@zapier/common-utils/src/setHocDisplayName';

function withMapProps<P extends Object, M extends Object>(
  Component: React.ComponentType<P>,
  map: (m: M) => P
) {
  const WithMapProps = function WithMapProps(props: M) {
    const mappedProps = map(props);
    return <Component {...mappedProps} />;
  };
  setHocDisplayName(WithMapProps, Component);
  return React.memo(WithMapProps);
}

export default withMapProps;
